import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CartProvider from "./context/CartContext";
import SearchProvider from "./context/SearchContext";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <SearchProvider>
    <CartProvider>
      <App />
    </CartProvider>
  </SearchProvider>
);